import { Image } from '@chakra-ui/react';
import { getAsset, getTenantByHost } from '@pelicargo/tenants';

const { name, customerTheme } = getTenantByHost();

type Props = {
  filename?: string;
  height?: number;
  width?: number;
  fullSized?: boolean;
};

export const Logo = ({ filename = 'logo.svg', height, width, fullSized }: Props) => {
  return (
    <Image
      src={getAsset(filename)}
      height={height ?? customerTheme?.[fullSized ? 'fullLogoDims' : 'logoDims']?.height}
      width={width ?? customerTheme?.[fullSized ? 'fullLogoDims' : 'logoDims']?.width}
      objectFit="contain"
      alt={`${name} Logo`}
    />
  );
};
